export const DISTRIBUTOR_UNITS_SET = 'DISTRIBUTOR_UNITS_SET'
export const DISTRIBUTOR_UNITS_UPDATE = 'DISTRIBUTOR_UNITS_UPDATE'
export const DISTRIBUTOR_UNITS_FETCHING = 'DISTRIBUTOR_UNITS_FETCHING'
export const DISTRIBUTOR_UNITS_UPDATING = 'DISTRIBUTOR_UNITS_UPDATING'
